import React, { useState } from 'react';
import new_project_sample from 'images/new_pop_ups/new_project_sample.svg';
import { Button, InputNumber, Select, Modal, Form, Input } from 'antd';
import { createSample } from 'services/home';

const { Option } = Select;

const ProjectSampleModal = (props) => {
    const [sampleName, setSampleName] = useState('');
    const [selectedNumber, setSelectedNumber] = useState(null);
    const [selectedType, setSelectedType] = useState('Percent');
    const [fullDatasetSample, setFullDatasetSample] = useState('FullDataset');

    const handleChangeInputName = (e) => {
        setSampleName(e.target.value);
    };

    const handleChangeInputType = (value) => {
        setSelectedType(value);
    };

    const handleChangeInputNumber = (value) => {
        setSelectedNumber(value);
    };

    const handleVisibility = () => {
        setSampleName('');
        props.setIsModalVisible(false);
    };

    const sendDataSample = () => {
        let data = {
            name: sampleName,
            upload: props.sampleUploadId,
            sample_size:
                fullDatasetSample == 'FullDataset' ? 100 : selectedNumber,
            sample_size_type:
                fullDatasetSample == 'FullDataset' ? 'Percent' : selectedType
        };
        createSample(data).then((res) => {
            if (res.status == 201) {
                // props.setOpenFirstRow(true);
                props.handleTableRender();
                props.setSelectRow([props.sampleUploadId]);
                // setTimeout(() => {
                //     props.setSelectRow([newFirstRowId]);
                // }, 4000);
            }

            setSampleName('');
            setSelectedNumber(null);
        });

        props.setIsModalVisible(false);
    };

    // console.log(`setSampleName('')`, sampleName);

    return (
        <>
            <Modal
                className="basic-modal samplepopup"
                title=""
                visible={props.visible}
                onOk={handleVisibility}
                onCancel={handleVisibility}
                footer={null}
                closable={false}
                bodyStyle={{ height: 630 }}
                width={400}
            >
                <div className="icon-container">
                    <img
                        src={new_project_sample}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div className="remove-animation-form-sample">
                    <div>
                        <p
                            className="header-title"
                            style={{ marginBottom: '40px' }}
                        >
                            New Project/Sample
                        </p>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '40px' }}
                        >
                            <strong style={{ fontFamily: 'Roboto Bold' }}>
                                Full Dataset:
                            </strong>{' '}
                            Create a new project using the entirety of the
                            dataset.
                            <br />
                            <br />
                            <strong style={{ fontFamily: 'Roboto Bold' }}>
                                Random Sample:
                            </strong>{' '}
                            Create a new project using a smaller sample size
                            that you can set by percent or number of rows.
                        </p>
                    </div>
                    <div className="selected-data-button-container">
                        <div
                            className="box"
                            style={{
                                border: '1px solid #407CB1',
                                flexWrap: 'nowrap',
                                width: '238px',
                                marginBottom: 27
                            }}
                        >
                            <button
                                style={{ width: '103px', margin: 0 }}
                                className={
                                    fullDatasetSample == 'FullDataset'
                                        ? 'button-selected-sample'
                                        : 'button-unselected-sample'
                                }
                                onClick={() => {
                                    setFullDatasetSample('FullDataset');
                                }}
                            >
                                FULL DATASET
                            </button>

                            <button
                                style={{ width: '130px', margin: 0 }}
                                className={
                                    fullDatasetSample == 'Sample'
                                        ? 'button-selected-sample'
                                        : 'button-unselected-sample'
                                }
                                onClick={() => {
                                    setFullDatasetSample('Sample');
                                }}
                            >
                                RANDOM SAMPLE
                            </button>
                        </div>
                    </div>

                    <Form>
                        <Form.Item
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            label="Name your project: "
                            name="project_name"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please Input project name'
                                }
                            ]}
                        >
                            <Input
                                placeholder="Project name"
                                onChange={handleChangeInputName}
                                defaultValue={sampleName}
                                // initialValues={sampleName}
                                style={
                                    fullDatasetSample == 'Sample'
                                        ? {
                                              marginBottom: '0px',
                                              transition: 'none',
                                              //   color: '#828389'
                                              color: '#000',
                                              paddingLeft: 5
                                          }
                                        : {
                                              marginBottom: '96px',
                                              transition: 'none',
                                              //   color: '#828389'
                                              color: '#000',
                                              paddingLeft: 5
                                          }
                                }
                            />
                        </Form.Item>
                    </Form>

                    {fullDatasetSample == 'Sample' ? (
                        <Form>
                            <Form.Item
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                label="Size of Random Sample:"
                                name="random_sample"
                                rules={[
                                    {
                                        required: false,
                                        message: 'Please Input sample size'
                                    }
                                ]}
                                style={
                                    fullDatasetSample == 'Sample'
                                        ? {
                                              marginBottom: '40px',
                                              //   transition: 'none'
                                              color: '#828389'
                                          }
                                        : {
                                              marginBottom: '0px',
                                              color: '#828389'
                                              //   transition: 'none'
                                          }
                                }
                            >
                                <InputNumber
                                    onChange={handleChangeInputNumber}
                                    value={selectedNumber}
                                    style={{
                                        width: 'auto',
                                        marginRight: 10,
                                        border: 'none',
                                        // color: '#828389'
                                        color: '#000'
                                    }}
                                    placeholder="Type number here..."
                                ></InputNumber>
                                <Select
                                    onChange={handleChangeInputType}
                                    defaultValue={selectedType}
                                    style={{
                                        width: 'auto',
                                        // color: '#828389',
                                        color: '#000'
                                    }}
                                >
                                    <Option value="Percent">Percent</Option>
                                    <Option value="Rows">Rows</Option>
                                </Select>
                            </Form.Item>
                        </Form>
                    ) : null}
                    <div style={{ paddingTop: '33px' }}>
                        {fullDatasetSample == 'FullDataset' ? (
                            sampleName !== '' ? (
                                <button
                                    className="ant-btn ant-btn-primary ant-btn-block blue-button"
                                    onClick={sendDataSample}
                                    style={{
                                        width: '100%',
                                        marginTop: 10,
                                        height: 26
                                    }}
                                >
                                    CREATE
                                </button>
                            ) : (
                                <Button
                                    disabled
                                    type="button"
                                    className="ant-btn ant-btn-default"
                                    style={{ width: '100%', marginTop: 10 }}
                                >
                                    <span>CREATE</span>
                                </Button>
                            )
                        ) : null}

                        {fullDatasetSample == 'Sample' ? (
                            sampleName !== '' && selectedNumber ? (
                                <button
                                    className="ant-btn ant-btn-primary ant-btn-block blue-button"
                                    onClick={sendDataSample}
                                    style={{
                                        width: '100%',
                                        marginTop: 10,
                                        height: 26
                                    }}
                                >
                                    CREATE
                                </button>
                            ) : (
                                <Button
                                    disabled
                                    type="button"
                                    className="ant-btn ant-btn-default"
                                    style={{ width: '100%', marginTop: 10 }}
                                >
                                    <span>CREATE</span>
                                </Button>
                            )
                        ) : null}

                        {/* {(sampleName !== '' && selectedNumber) ||
                        fullDatasetSample == 'Sample' ? (
                            <button
                                className="ant-btn ant-btn-primary ant-btn-block blue-button"
                                onClick={sendDataSample}
                                style={{
                                    width: '100%',
                                    marginTop: 10,
                                    height: 26
                                }}
                            >
                                CREATE
                            </button>
                        ) : (
                            <Button
                                disabled
                                type="button"
                                className="ant-btn ant-btn-default"
                                style={{ width: '100%', marginTop: 10 }}
                            >
                                <span>Project size not set</span>
                            </Button>
                        )} */}

                        <button
                            onClick={() => {
                                handleVisibility();
                            }}
                            style={{
                                width: '100%',
                                marginTop: 10,
                                color: '#407CB1',
                                height: '26px',
                                backgroundColor: '#fff',
                                border: '1px solid #578CBA'
                            }}
                        >
                            CANCEL
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ProjectSampleModal;
